import { render, staticRenderFns } from "./layout-delete.vue?vue&type=template&id=51c4e4c8"
import script from "./layout-delete.vue?vue&type=script&lang=js"
export * from "./layout-delete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src837179331/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51c4e4c8')) {
      api.createRecord('51c4e4c8', component.options)
    } else {
      api.reload('51c4e4c8', component.options)
    }
    module.hot.accept("./layout-delete.vue?vue&type=template&id=51c4e4c8", function () {
      api.rerender('51c4e4c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/layout-delete.vue"
export default component.exports